import React from 'react';
import SidebarMenu from './SidebarMenu';
import mpsLogo from '../../../assets/images/mps_logo.png';

const Sidebar = ({ onTabChange }) => {


  return (
    <div 
      className="shadow-1xl"
    >
      {/* Glass Header */}

      <div 
        className="bg-[#fefcff] border-none p-2 flex justify-center items-center hidden md:flex"
      >
        <img 
          src={mpsLogo}
          alt="Enable LXP Logo" 
          className="w-32 h-14 object-contain drop-shadow-md transition-transform hover:scale-105"
        />
      </div>

      {/* Menu */}
      <div 
        className="flex-1 overflow-y-auto scrollbar-thin brand-app-sidebar-scroll brand-app-sidebar border-r"
      >
        <SidebarMenu onTabClick={onTabChange} />
      </div>
    </div>
  );
};

export default Sidebar;